var render = function render(){var _vm=this,_c=_vm._self._c;return _c('photo-book-cover-preview',{attrs:{"token":_vm.currentPhotoBook.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }